// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","footer-center":"Footer_footer-center__7ZLtF"};